import React, { useState, useEffect } from 'react';
import { Container } from 'react-bootstrap';
import { LanguageProvider } from '../../core/language-provider';
import VideoPlayer from '../../components/EpisodePlayer/Video';
import SurveyPlayer from '../../components/EpisodePlayer/Survey';
import LivePlayer from '../../components/EpisodePlayer/Live';
import FilePlayer from '../../components/EpisodePlayer/File';


export default function Episode({course, episode}) {


    useEffect(() => {
        if(episode !== null) {
            console.log('--- get episode content ---')
            console.warn('episode component', episode)
        }
    }, [episode]);


    return (
        <Container fluid='md' className='mt-5 mb-5'>

            {episode && episode.type && episode.type.value === 'video' &&
                <VideoPlayer episode={episode} />
            }

            {episode && episode.type && episode.type.value === 'survey' &&
                <SurveyPlayer episode={episode} />
            }

            {episode && episode.type && episode.type.value === 'live' &&
                <LivePlayer episode={episode} />
            }

            {episode && episode.type && episode.type.value === 'file' &&
                <FilePlayer episode={episode} />
            }

        </Container>
    );
};